import produce from 'immer';
import { TCommentariesActions, TCommentariesState } from '../../types/redux/commentaries';
import { COMMENTARIES_SET_DATA } from '../actions/commentaries';

const initialState: TCommentariesState = {};

export const commentaries = (state = initialState, action: TCommentariesActions): TCommentariesState => {
    switch (action.type) {
        case COMMENTARIES_SET_DATA: {
            return produce(state, (draft) => {
                draft[action.payload.dataIndex] = action.payload.data;
            });
        }
        default: {
            return state;
        }
    }
};
